import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-switch_guide-click';
/**
 * Switching to retailer&#x2F;brand guides
 */
export function trackHelpCenterSwitchGuideClick(target) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { target },
    });
}
